import { useEffect, useState } from 'react';
import { ChangeAlertCallbackType } from '../../../Root';
import { useAFBFunction } from '../../../customwidgets/afb-company-admin/hooks/useAFBFunction';
import { useCRMFunction } from '../../../customwidgets/leads-crm/hooks/useCRMFunction';

export const useUpdateCRM = (open: boolean, customer: any, crmData: any, companyGroups: any, reloadData: Function, closelightbox: Function, changeAlert: ChangeAlertCallbackType) => {
    const { handleCustomerSegmentUpdate } = useAFBFunction(changeAlert);
    const { onHandleLeadUpdate, onHandleGroupUpdate, onHandleGroupAdd } = useCRMFunction(changeAlert);

    const [zPos, setZPos] = useState(45);
    const [form, setForm] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [initialGroup, setInitialGroup] = useState(null);
    const [company, setCompany] = useState(null);

    const onHandleChange = (key, e) => {
        let f = form;
        let g = initialGroup;
        let value = e.target.value;

        if (key) {
            f[key] = value;
        }
        if (key === 'company_group' && value) {
            if (g) {
                let cleanList= g['partner_list'].filter((j) => j.uuid !== form["uuid"]);
                g['partner_list'] = cleanList;
                setInitialGroup(JSON.parse(JSON.stringify(g)));
            } 
        }

        if (!value) {
            setError(true);
            setDisabled(true);
        } else {
            setError(false);
            setDisabled(false);
        }

        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onHandleUpdate = async () => {
        setLoading(true);
        setZPos(-1);

        let resp = await handleCustomerSegmentUpdate(form);
        if (resp) {
            if (crmData) {
                let payload = {
                    uuid: crmData.uuid,
                    general: {company_group: form['company_group'], segment: form['segment']}
                };
    
                let add = {
                    uuid: form["company_group"],
                    partner_list: company
                };
                
                Promise.all([
                    onHandleLeadUpdate(payload),
                    onHandleExecute(initialGroup, add)
                ]).then(results => {
                    changeAlert(true, 'success', 'El registro se actualizó con éxito');
                }).catch((error) => {
                    changeAlert(true, 'error', 'Error: ' + error);
                    setZPos(45);
                    setLoading(false);
                })
            } else {
                changeAlert(true, 'error', 'Error: El Cliente fue actualizado pero no cuenta con registro en el CRM.');
            }

            await reloadData(form.customer.uuid);
        }
        setZPos(45);
        setLoading(false);
        closelightbox();
    };

    const onHandleExecute = async (update, add) => {
        if (update) {
            onHandleGroupUpdate(update)
        }
        onHandleGroupAdd(add);
        return true;
    };

    useEffect(() => {
        if (!open) {
            setError(false);
            setDisabled(true);
        }
        if (customer) {
            setForm({
                customer: { uuid: customer.uuid },
                segment: customer.segment,
                company_group: customer.company_group
            })
            if (customer['company_group']) {
                let groups = companyGroups.find(item => item.uuid === customer['company_group'])?.partner_list;
                setInitialGroup({
                    uuid: customer['company_group'],
                    partner_list: groups
                });
            }
            setCompany({
                uuid: customer['uuid'],
                company_name: customer['corporate_name']
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, customer, crmData]);

    return {
        zPos,
        form,
        error,
        loading,
        disabled,
        onHandleChange,
        onHandleUpdate
    };
};
